// extracted by mini-css-extract-plugin
module.exports = {"fillOutSpace":"Sidebar_fillOutSpace__29jeZ","hideOnMobile":"Sidebar_hideOnMobile__2ZKOS","displayingNotification":"Sidebar_displayingNotification__22IiL"};